import { Result } from '../../index';

// Namespace
import * as ProposalNS from '../../../modules/proposal/Proposal';

// Utils
import { overrideItemColors } from '../../../modules/proposal/utils/proposal';
import ComparisonItem from '@/types/comparison-item';

// TODO: Regroup all action creators in their own file to fix Redux dependency cycles
export const refreshProposalItems =
  (newItems: ComparisonItem[]): Result<void> =>
  async (dispatch, getState) => {
    const {
      proposalV2: { items, selectedTemplate },
      comparisonCorrelations,
    } = getState();

    if (!selectedTemplate || selectedTemplate.builderVersion !== ProposalNS.ProposalBuilderVersion.V2) {
      return;
    }

    let proposalItems = items.map(i => {
      const newItem = newItems.find(item => item._id === i._id);

      if (!newItem) {
        throw new Error('Unable to find matching comparison item for proposal item');
      }

      return newItem;
    });

    proposalItems = overrideItemColors(selectedTemplate, proposalItems);

    dispatch({ type: 'connect/proposal-v2/set-proposal-items', items: proposalItems });
    dispatch({ type: 'connect/proposal-v2/set-proposal-items-correlation', itemsCorrelation: comparisonCorrelations });
  };
